import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import CustomDialog from "global/components/CustomDialog/CustomDialog";
import { deleteSender } from "../SendersService";
import { handleErrorMessage, openSuccessNotification } from "helpers/methods";

interface CustomProps {
  isVisible: boolean;
  handleDialogClose: Function;
  filters: any;
  setFilters: Function;
  verificationDetails: any;
}
const SenderDeleteModal = (props: CustomProps) => {
  const theme = useTheme();
  const {
    isVisible,
    handleDialogClose,
    filters,
    setFilters,
    verificationDetails,
  } = props;

  const handleDeleteSender = async () => {
    try {
      const response = await deleteSender(verificationDetails?.senderId);
      openSuccessNotification(response?.message);
      handleDialogClose();
      setFilters({
        ...filters,
        page: 1,
      });
    } catch (error: any) {
      handleErrorMessage(error);
    }
  };

  const getTitle = () => {
    return (
      <Typography variant="h4" color={theme.palette.primary.main}>
        Please confirm
      </Typography>
    );
  };

  const getBody = () => {
    return (
      <>
        <Stack spacing={3} pt={1}>
          <Typography textAlign="center">
            {`${"Are you sure you want to delete the sender "}`}
            <span style={{ fontWeight: 700 }}>
              {verificationDetails?.senderEmail}?
            </span>
          </Typography>
        </Stack>
      </>
    );
  };

  const getFooter = () => {
    return (
      <Stack direction="row" spacing={2}>
        <Button
          id="delete_comment_no"
          size="small"
          variant="outlined"
          onClick={() => handleDialogClose()}
        >
          Cancel
        </Button>
        <Button
          id="delete_comment_yes"
          size="small"
          variant="contained"
          onClick={() => handleDeleteSender()}
        >
          Delete
        </Button>
      </Stack>
    );
  };

  return (
    <CustomDialog
      isDialogOpen={isVisible}
      title={getTitle()}
      body={getBody()}
      footer={getFooter()}
      handleDialogClose={() => handleDialogClose()}
      closable
      closeButtonVisibility
      persistOnClickOutside
      persistOnEsc
    />
  );
};

export default SenderDeleteModal;
